import { combineReducers } from 'redux';

import lastPayout from './lastPayout';


export default combineReducers({
  lastPayout,
});
